<script lang="ts" setup>
const props = defineProps<{
  __typename?: string;
}>();

/**
 * reslove dynamic component
 * prepare component name
 * add template prefix because components are in the template folder
 * split by capital letters concat with -
 */
const component = computed(() => {
  const componentName = `template-${props.__typename
    ?.split(/(?=[A-Z])/)
    .join("-")
    .toLowerCase()}`;
  try {
    return resolveComponent(componentName);
  } catch (_e) {}
  return resolveComponent("template-page");
});
</script>
<template>
  <component :is="component" v-if="component" v-bind="$attrs" />
</template>
